import React, { useState } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
// import DialogTitle from '@material-ui/core/DialogTitle'
// import DialogTitle from '../../components/ui/Dialog/DialogTitle'
// import DialogActions from '../../components/ui/Dialog/DialogActions'
// import DialogContent from '@material-ui/core/DialogContent'
// import MuiDialogActions from '@material-ui/core/DialogActions'
import {
  DialogContent,
  DialogTitle,
  DialogActions,
} from "../../components/ui/Dialog/CustomDialog";

import Button from "@material-ui/core/Button";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AttachmentIcon from "@material-ui/icons/Attachment";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import CancelIcon from "@material-ui/icons/Cancel";
import LinearProgress from "@material-ui/core/LinearProgress";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import { FormControl, FormControlLabel } from "@material-ui/core";
import toast, { Toaster } from "react-hot-toast";
import {
  getAddressIssueAttachment,
  respondToAddressIssue,
} from "../../serviceClients/addressingClient";
import {
  addressingApiResponseMapper,
  addressIssuesMapper,
} from "../../components/mappers/addressingMappers";
//import Viewer from 'react-viewer'; //TODO check and implement
import { useToasts } from "react-toast-notifications";
import { triggerBase64Download } from "react-base64-downloader";
import { makeStyles } from "@material-ui/core/styles";
import { Rotate90DegreesCcw } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
const ISSUE_STATUS_OPEN_ID = "1"; //HARDCODE database value
const ISSUE_STATUS_CLOSED_ID = "3";

const useStyles = makeStyles((theme) => ({
  attachmenticon: {
    transform: "rotate(270deg)",
  },
}));

function IssueDetailsDisplay(props) {
  const { t, i18n } = useTranslation("issueInboxPage");
  const classes = useStyles();
  const { addToast } = useToasts();
  const AdddressIssueTypesHashMap = props.addressIssueTypes
    ? props.addressIssueTypes.data.reduce((map, obj) => {
        map[obj.id] = obj.name;
        return map;
      }, {})
    : {};

  const AdddressIssueStatusTypesHashMap = props.addressIssueStatusTypes
    ? props.addressIssueStatusTypes.data.reduce((map, obj) => {
        map[obj.id] = obj.name;
        return map;
      }, {})
    : {};

  const [respondTxt, setRespondTxt] = useState("");
  //   const [attachmentImg , setAttachmentImg ] = useState('')

  const loggedInCustodianName = props.loginUserDetails
    ? props.loginUserDetails.userName
    : null;

  const issueInfo = props.issueInfo.data[0];
  const issueId = issueInfo.id;
  const issueType =
    issueInfo && issueInfo.fk_Issue_TypeId
      ? AdddressIssueTypesHashMap[issueInfo.fk_Issue_TypeId]
      : "";
  const issueStatusId =
    issueInfo && issueInfo.fK_Issue_StatusId ? issueInfo.fK_Issue_StatusId : "";
  const reportedDate =
    issueInfo && issueInfo.reportedDate ? issueInfo.reportedDate : "";
  const reportedUserName =
    issueInfo && issueInfo.reportUserName ? issueInfo.reportUserName : "";
  const reporterEmail = issueInfo && issueInfo.email ? issueInfo.email : "";

  const [isSubmintInProgress, setIsSubmitInProgress] = useState(false);
  // if(issueInfo && issueInfo.responderComments)  setRespondTxt(issueInfo.responderComments)

  const isRespondedStatus = issueStatusId == ISSUE_STATUS_CLOSED_ID;

  const getAndDisplayIssueAttachment = (issueId) => {
    const [promise, source] = getAddressIssueAttachment(
      issueId,
      props.appSettings.userCredentials.token.access_token
    );
    promise
      .then((aresp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          pageNo,
          pageSize,
          totalCount,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(aresp.data);
        if (isSuccess) {
          //addToast("Downloaded Successfully " ,  { appearance: 'error' })
          //addToast("Downloaded Successfully " ,  { appearance: 'success' })
          //setAttachmentImg(respData[0].fileContent)
          respData.forEach((item) => {
            let fileContent = item.fileContent;
            let fileName = item.fileName;
            triggerBase64Download(fileContent, fileName);
          });
        } else {
          alert("Failed to get attachment");
        }
      })
      .catch((err) => {
        console.log(err.message);
        alert("Failed to get attachment " + err.message);
      })
      .then(() => {
        //done
      });
  };

  const sendResponseToUser = () => {
    if (respondTxt.trim().length < 1) {
      toast.error("Please Enter Responder Comments");
      return;
    }
    setIsSubmitInProgress(true);
    let responderName = loggedInCustodianName;
    const [promise, source] = respondToAddressIssue(
      issueId,
      responderName,
      respondTxt,
      props.appSettings.userCredentials.token.access_token
    );
    promise
      .then((aresp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          pageNo,
          pageSize,
          totalCount,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(aresp.data);
        if (isSuccess) {
          //var updatedIssueInfo = addressIssuesMapper(respData)
          // props.issueInfo = { data : [updatedIssueInfo]}
          toast.success("Response Sent to the user");
          props.onClose(); //close the Dialog
        } else {
          toast.error("Unalbe to send response to the user");
        }
      })
      .catch((err) => {
        console.log(err.message);
        toast.error(err.message);
      })
      .then(() => {
        //done
        setIsSubmitInProgress(false);
      });
  };
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        maxWidth={props.maxWidth || "md"}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={props.onClose}
          disabled={isSubmintInProgress}
        >
          Issue Details
          {/* {JSON.stringify(issueInfo)} */}
        </DialogTitle>
        <DialogContent dividers>
          {/* <Grid container>
                <Grid item xs={6}>
                    <FormControl>
                        <FormControlLabel value="top" label="top" labelPlacement="top">

                        </FormControlLabel>
                    </FormControl>
                </Grid>
            </Grid> */}

          <Grid container justify="center">
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={issueType}
                        secondary={t("IssueType")}
                      />
                      <Tooltip title="download attachments">
                        {/* <Avatar
                            aria-label="download attachments"
                            size="small"
                            variant="rounded"
                           // className={classes.purple}
                            onClick={() =>
                              getAndDisplayIssueAttachment(issueId)
                            }
                          > */}
                        <Fab
                          color="primary"
                          size="medium"
                          onClick={() => getAndDisplayIssueAttachment(issueId)}
                        >
                          <AttachmentIcon
                            color="default"
                            className={classes.attachmenticon}
                          />
                        </Fab>
                        {/* </Avatar> */}
                      </Tooltip>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={3}>
                  <List>
                    <ListItem>
                      {/* <ListItemAvatar>
                          <Avatar>
                            <ImageIcon />
                          </Avatar>
                        </ListItemAvatar> */}
                      <ListItemText
                        primary={reportedDate}
                        secondary={t("ReportedOn")}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={5}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={`${reportedUserName} ( ${reporterEmail} )`}
                        secondary={t("ReportedBy")}
                      />
                    </ListItem>
                  </List>
                </Grid>
                {/* <Grid item xs={1}>
                    <Tooltip title="download attachments">
                      <Fab
                        aria-label="download attachments"
                        size="small"
                        variant="extended"
                        color="primary"
                        onClick={() => getAndDisplayIssueAttachment(issueId)}
                      >
                        <AttachmentIcon />
                      </Fab>
                    </Tooltip>
                  </Grid> */}
              </Grid>

              <Grid container>
                <Grid item xs={12}>
                  {/* <Avatar
                      variant="rounded"
                      color="secondary"
                      onClick={() => alert("will display attachments")}
                    >
                      <AttachmentIcon />
                    </Avatar>
                    <Tooltip title="view attachment">
                      <IconButton
                        aria-label="view attachment"
                        color="primary"
                        onClick={() =>
                          alert("will fetch and display attachment")
                        }
                      >
                        <AttachmentIcon />
                      </IconButton>
                    </Tooltip> */}
                  <div> {t("IssueDescription")} </div>
                  <TextareaAutosize
                    style={{ width: "100%" }}
                    value={issueInfo.reporterDescription}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12}>
                  {t("RespondToReporter")}
                  <TextareaAutosize
                    rows={10}
                    style={{ width: "100%" }}
                    onChange={(e) => setRespondTxt(e.target.value)}
                    value={
                      isRespondedStatus
                        ? issueInfo.responderComments
                        : respondTxt
                    }
                    disabled={isRespondedStatus}
                  ></TextareaAutosize>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item>  
                <Viewer visible={attachmentImg} onClose={()=> {
                    setAttachmentImg('')
                 }} images={[{src:attachmentImg , alt:'unable to load Image'}]}/>
            </Grid> */}
        </DialogContent>

        <DialogActions>
          <Button
            autoFocus
            color="secondary"
            variant="outlined"
            onClick={() => props.onClose()}
            startIcon={isRespondedStatus ? <CloseIcon /> : <CancelIcon />}
            disabled={isSubmintInProgress}
          >
            {isRespondedStatus ? t("CloseBtn") : "Cancel"}
          </Button>

          {isRespondedStatus ? null : (
            <Button
              autoFocus
              color="primary"
              variant="contained"
              onClick={() => {
                sendResponseToUser();
              }}
              startIcon={<SendIcon />}
              disabled={isSubmintInProgress}
            >
              Send
            </Button>
          )}
        </DialogActions>
        {isSubmintInProgress ? <LinearProgress /> : null}
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    addressIssueTypes: state.addressIssueTypes,
    addressIssueStatusTypes: state.addressIssueStatusTypes,
    loginUserDetails: state.settings.userCredentials
      ? state.settings.userCredentials.user
      : null,
    appSettings: state.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueDetailsDisplay);
